import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

/** A link to copy, and its button. */
export function Copyable({ label, link }: { label: string; link: string }) {
  const { t } = useTranslation();
  const id = useId();
  const [copied, setCopied] = useState(false);
  return (
    <div className="copyable">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <div className="copy-row">
        <input id={id} className="text-input" type="text" readOnly value={link} />
        <button
          type="button"
          className="button"
          onClick={() => {
            navigator.clipboard.writeText(link).then(
              () => {
                setCopied(true);
              },
              () => undefined,
            );
          }}
        >
          {t(copied ? 'group.copied' : 'group.copy')}
        </button>
      </div>
    </div>
  );
}
